import { useEffect, useState } from "react";

import {
    Alert,
    Card,
    CardBody,
    CardHeader,
    Container,
    Spinner
} from "reactstrap";

import GroupCreationRequestService
from "../Services/GroupCreationRequestService";

import { GroupCreationRequestDto }
from "../types/GroupCreationRequest";
import GroupRequestTable from "./GroupRequestTable";
 

const AdminGroupRequestListPage = () => {

    const [requests, setRequests] =
        useState<GroupCreationRequestDto[]>([]);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    useEffect(() => {

        loadRequests();

    }, []);

    const loadRequests = async () => {

        setLoading(true);

        try {

            const response =
                await GroupCreationRequestService.getAll();

            setRequests(response);

        }
        catch {

            setError(
                "Unable to load requests."
            );

        }
        finally {

            setLoading(false);

        }

    };

    if (loading)

        return (

            <Container className="text-center mt-5">

                <Spinner />

            </Container>

        );

    return (

        <Container fluid>

            <Card>

                <CardHeader>

                    <h4 className="mb-0">

                        Group Creation Requests

                    </h4>

                </CardHeader>

                <CardBody>

                    {

                        error &&

                        <Alert color="danger">

                            {error}

                        </Alert>

                    }

                    <GroupRequestTable

                        requests={requests}

                        refresh={loadRequests}

                    />

                </CardBody>

            </Card>

        </Container>

    );

};

export default AdminGroupRequestListPage;